import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IPaymentConfigEntity } from '../../../entity';

export interface IGetCountryConfigsUseCase {
    execute(
        username: string,
        identityToken: string,
        apiKey: string,
        authToken: string,
        authSign: string,
        csrfToken: { [key: string]: string }
    ): Promise<IPaymentConfigEntity>;
}

export class GetCountryConfigsUseCase implements IGetCountryConfigsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        username: string,
        identityToken: string,
        apiKey: string,
        authToken: string,
        authSign: string,
        csrfToken: { [key: string]: string }
    ): Promise<IPaymentConfigEntity> {
        return await this.userRepo.getCountryConfigs(username, identityToken, apiKey, authToken, authSign, csrfToken);
    }
}
